import React, { useState } from 'react'
import { Layout, Button, Drawer } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import Foot from './Foot'
import styles from './webMainH5.module.css'
import { H5 } from './h5Routes'

const { Content } = Layout

function WebMain(props) {
    const navi = useNavigate()
    const [drawerOpen, setDrawerOpen] = useState(false)

    const closeAnd = (fn) => {
        setDrawerOpen(false)
        fn()
    }

    const menuRows = [
        { label: '首页', key: 'product', path: H5.INDEX },
        { label: '产品介绍', key: 'goods', path: H5.GOODS },
        { label: '关于我们', key: 'about', path: H5.ABOUT },
        { label: '公司新闻', key: 'news', path: H5.NEWS },
        { label: '在线客服', key: 'contact', path: H5.SERVICE },
    ]

    return (
        <Layout className={styles.layout}>
            <header className={styles.header}>
                <span
                    className={styles.logo}
                    onClick={() => navi(H5.INDEX)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') navi(H5.INDEX)
                    }}
                >
                    伯纳思
                </span>
                <div className={styles.headerRight}>
                    <a className={styles.pcLink} href="/" target="_blank" rel="noreferrer">
                        电脑版
                    </a>
                    <Button
                        type="text"
                        className={styles.menuBtn}
                        icon={<MenuOutlined />}
                        onClick={() => setDrawerOpen(true)}
                        aria-label="打开导航"
                    />
                </div>
            </header>
            <Drawer
                title="导航"
                placement="right"
                onClose={() => setDrawerOpen(false)}
                open={drawerOpen}
                width={280}
            >
                {menuRows.map((row) => (
                    <div
                        key={row.key}
                        className={styles.drawerMenuItem}
                        onClick={() =>
                            closeAnd(() => {
                                navi(row.path)
                            })
                        }
                        style={{
                            fontWeight: props.selectedKeys === row.key ? 600 : 400,
                            color: props.selectedKeys === row.key ? '#e20001' : undefined,
                        }}
                    >
                        {row.label}
                    </div>
                ))}
            </Drawer>
            <Content className={styles.content}>{props.children}</Content>
            <Foot />
        </Layout>
    )
}

export default WebMain
